function filterGamecards(platform) {
	const filterHeading = document.querySelector("#heading-platforms");
	const selectedPlatform = document.querySelector("#_selected_platform");

	if (platform) {
		filterHeading.classList.add("active");
		selectedPlatform.dataset.platform = platform;
		selectedPlatform.innerHTML = platform;
		selectedPlatform.parentNode.querySelector("svg").classList.remove("d-none");
		for (const gamecard of document.querySelectorAll("._gamecard")) {
			const platforms = JSON.parse(gamecard.dataset.platforms);
			const foundPlatform = platforms.filter((item) => item.name === platform);
			if (foundPlatform.length === 0) {
				gamecard.classList.add("d-none");
			} else {
				gamecard.classList.remove("d-none");
			}
		}
		for (const heading of document.querySelectorAll("h2[data-week]")) {
			const week = heading.dataset.week;
			const visibleGamecards = document.querySelectorAll(
				`._gamecard[data-week="${week}"]:not(.d-none)`,
			);
			if (visibleGamecards.length === 0) {
				heading.classList.add("d-none");
			} else {
				heading.classList.remove("d-none");
			}
		}
	} else {
		filterHeading.classList.remove("active");
		selectedPlatform.dataset.platform = "";
		selectedPlatform.innerHTML = "Tutte";
		selectedPlatform.parentNode.querySelector("svg").classList.add("d-none");
		for (const gamecard of document.querySelectorAll("._gamecard")) {
			gamecard.classList.remove("d-none");
		}
		for (const heading of document.querySelectorAll("h2[data-week]")) {
			heading.classList.remove("d-none");
		}
	}
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const platformFilter = document.querySelector("#_platform_filter");
	const selectedPlatform = document.querySelector("#_selected_platform");
	if (platformFilter) {
		for (const el of document.querySelectorAll("._selected_platform")) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				filterGamecards();
			});
		}

		for (const li of platformFilter.querySelectorAll("li")) {
			li.addEventListener("click", (event) => {
				event.preventDefault();
				const platform = event.target.dataset.platform;
				if (
					!selectedPlatform.dataset.platform ||
					selectedPlatform.dataset.platform !== platform
				) {
					filterGamecards(platform);
				}
			});
		}
	}
});
